import React from 'react';
import { useNavigate } from 'react-router-dom';
import './StudyDetails.css';

const StudyDetailsExternal: React.FC = () => {
  const navigate = useNavigate();

  const handleBackToLogin = () => {
    navigate('/login');
  };

  return (
    <div className="study-details-container">
      <div className="study-details-screen">
        <div className="study-details-header">
          <h1>Study Details</h1>
          <p>Learn about this research study</p>
        </div>

        <div className="study-details-content">
          <section className="study-section">
            <h2>Overview</h2>
            <p>
            Thank you for participating in this activity. RSAC studying how human experts and LLMs respond to security and privacy relevant questions. For this we need help from experts like you! Below is some important information about what you are being asked to do and how your data will be used.
            </p>
          </section>

          <section className="study-section">
            <h2>Procedures</h2>
            <p>
          If you consent to the study, you will be asked to play a game. This game will ask you various questions about security and privacy. All you must do is to pay attention and answer to the best of your ability. You may play for as long as you want and pick whatever topics you'd like to answer questions for.
        </p>
          </section>

          <section className="study-section">
            <h2>Purpose</h2>
            <p>
            This study aims to compare the performance of humans and large language models (LLMs) on multiple-choice cybersecurity questions. Your expertise will enhance this challenge and help advance our understanding of LLM vs human performance.

            </p>
          </section>

          <section className="study-section">
            <h2>Data Collected</h2>
            <p>
            Your usage of the game (answers to questions, timing, and analytics), and professional demographics information you might have shared with us (job title, experience level etc.).
            </p>
          </section>

          <section className="study-section">
            <h2>Participant Rights</h2>
            <p>
            Participation is voluntary. Contributions will remain anonymous and only reported in aggregate. You may stop and/or withdraw participation at any time. You may play the game even if you do not consent to the study. In this case, your data will not be used for research.

            </p>
          </section>

          <section className="study-section">
            <h2>Contact Information</h2>
            <p>
            For questions, more information, or any requests please contact Omer Akgul at{' '}
            <a href="mailto:user.study@rsaconference.com.">user.study@rsaconference.com.</a>
            </p>
          </section>
        </div>

        <div className="study-details-actions">
          <button 
            className="back-to-login-button"
            onClick={handleBackToLogin}
          >
            Back to Login
          </button>
        </div>
      </div>
    </div>
  );
};

export default StudyDetailsExternal; 